import { useState } from 'react';
import LibraryDashboard from '@/components/library/LibraryDashboard';
import ResourceViewer from '@/components/library/ResourceViewer';
import { Resource } from '@/types/library';

type LibraryViewType = 'dashboard' | 'viewer';

export default function Library() {
  const [viewType, setViewType] = useState<LibraryViewType>('dashboard');
  const [selectedResource, setSelectedResource] = useState<Resource | null>(null);

  const handleSelectResource = (resource: Resource) => {
    setSelectedResource(resource);
    setViewType('viewer');
  };

  const handleBack = () => {
    setViewType('dashboard');
    setSelectedResource(null);
  };

  return (
    <div>
      {viewType === 'dashboard' && (
        <div className="min-h-screen bg-background p-6">
          <div className="max-w-7xl mx-auto">
            <LibraryDashboard onSelectResource={handleSelectResource} />
          </div>
        </div>
      )}

      {viewType === 'viewer' && selectedResource && (
        <ResourceViewer resource={selectedResource} onBack={handleBack} />
      )}
    </div>
  );
}
